'use strict';

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:registrar'), {
  error: debug('libp2p:registrar:err')
});

var errcode = require('err-code');

var _require = require('./errors'),
    ERR_INVALID_PARAMETERS = _require.codes.ERR_INVALID_PARAMETERS;

var Topology = require('libp2p-interfaces/src/topology');
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('./peer-store')} PeerStore
 * @typedef {import('./connection-manager')} ConnectionManager
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('./').HandlerProps} HandlerProps
 */

/**
 *
 */

/**
 * Responsible for notifying registered protocols of events in the network.
 */


var Registrar = /*#__PURE__*/function () {
  /**
   * @param {Object} props
   * @param {PeerStore} props.peerStore
   * @param {ConnectionManager} props.connectionManager
   * @class
   */
  function Registrar(_ref) {
    var peerStore = _ref.peerStore,
        connectionManager = _ref.connectionManager;

    _classCallCheck(this, Registrar);

    // Used on topology to listen for protocol changes
    this.peerStore = peerStore;
    this.connectionManager = connectionManager;
    /**
     * Map of topologies
     *
     * @type {Map<string, Topology>}
     */

    this.topologies = new Map();
    /** @type {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void} */
    // @ts-ignore handle is not optional

    this._handle = undefined;
    this._onDisconnect = this._onDisconnect.bind(this);
    this.connectionManager.on('peer:disconnect', this._onDisconnect);
  }
  /**
   * @returns {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void}
   */


  _createClass(Registrar, [{
    key: "handle",
    get: function get() {
      return this._handle;
    }
    /**
     * @param {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void} handle
     */
    ,
    set: function set(handle) {
      this._handle = handle;
    }
    /**
     * Get a connection with a peer.
     *
     * @param {PeerId} peerId
     * @returns {Connection | null}
     */

  }, {
    key: "getConnection",
    value: function getConnection(peerId) {
      return this.connectionManager.get(peerId);
    }
    /**
     * Register handlers for a set of multicodecs given
     *
     * @param {Topology} topology - protocol topology
     * @returns {string} registrar identifier
     */

  }, {
    key: "register",
    value: function register(topology) {
      if (!Topology.isTopology(topology)) {
        log.error('topology must be an instance of interfaces/topology');
        throw errcode(new Error('topology must be an instance of interfaces/topology'), ERR_INVALID_PARAMETERS);
      } // Create topology


      var id = (Math.random() * 1e9).toString(36) + Date.now();
      this.topologies.set(id, topology); // Set registrar

      topology.registrar = this;
      return id;
    }
    /**
     * Unregister topology.
     *
     * @param {string} id - registrar identifier
     * @returns {boolean} unregistered successfully
     */

  }, {
    key: "unregister",
    value: function unregister(id) {
      return this.topologies.delete(id);
    }
    /**
     * Remove a disconnected peer from the record
     *
     * @param {Connection} connection
     * @returns {void}
     */

  }, {
    key: "_onDisconnect",
    value: function _onDisconnect(connection) {
      var _iterator = _createForOfIteratorHelper(this.topologies),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              topology = _step$value[1];

          topology.disconnect(connection.remotePeer);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Registrar;
}();

module.exports = Registrar;